import { render, staticRenderFns } from "./selectpre.vue?vue&type=template&id=3d72c606&scoped=true&"
import script from "./selectpre.vue?vue&type=script&lang=js&"
export * from "./selectpre.vue?vue&type=script&lang=js&"
import style0 from "./selectpre.vue?vue&type=style&index=0&id=3d72c606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d72c606",
  null
  
)

export default component.exports